/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from '@mui/material';
import { DIMENSION_TABS } from './segmentConstants';

const SegmentDimensionTabs = ({ value, onChange, disabled }) => (
  <Tabs
    value={value}
    onChange={(_, next) => onChange(next)}
    variant="scrollable"
    scrollButtons="auto"
    sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}
  >
    {DIMENSION_TABS.map((tab) => (
      <Tab
        key={tab.id}
        value={tab.id}
        label={tab.label}
        disabled={disabled}
        sx={{ textTransform: 'none', fontWeight: 600, minHeight: 44 }}
      />
    ))}
  </Tabs>
);

SegmentDimensionTabs.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SegmentDimensionTabs.defaultProps = {
  disabled: false,
};

export default SegmentDimensionTabs;
